import React from 'react';
import { Award, Target, Users, TrendingUp, Shield, Zap } from 'lucide-react';
import Header from './components/Header11';
import Footer from './components/Footer11';

const About11 = () => {
    const values = [
        { icon: Award, title: 'Craftsmanship', description: 'Every stitch reflects generations of tailoring mastery passed down through India\'s finest artisans.' },
        { icon: Target, title: 'Precision', description: 'Measured twice, cut once. Our fits are engineered for the modern Indian man\'s physique.' },
        { icon: Shield, title: 'Quality', description: 'We source only the finest fabrics from mills across India and the world.' },
        { icon: Zap, title: 'Boldness', description: 'Fashion that makes a statement. Designs that command respect and attention.' },
    ];

    const stats = [
        { number: '10,000+', label: 'Men Styled' },
        { number: '500+', label: 'Wedding Outfits' },
        { number: '15+', label: 'Cities Served' },
        { number: '4.9', label: 'Customer Rating' },
    ];

    const team = [
        { name: 'Vikram Sethi', role: 'Founder & Creative Director', image: 'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { name: 'Arjun Kapoor', role: 'Head of Design', image: 'https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { name: 'Rahul Mehta', role: 'Master Tailor', image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Source+Sans+3:wght@300;400;600&display=swap');
            `}</style>

            <div style={{ fontFamily: "'Source Sans 3', -apple-system, sans-serif" }} className="min-h-screen bg-[#1C1917]">
                <Header />

                {/* Hero */}
                <section className="relative pt-[72px]" style={{ backgroundColor: '#1C1917' }}>
                    <div className="relative h-[50vh] sm:h-[60vh] overflow-hidden">
                        <img src="https://images.pexels.com/photos/3363204/pexels-photo-3363204.jpeg?auto=compress&cs=tinysrgb&w=1200" alt="About VEER" className="w-full h-full object-cover" style={{ opacity: 0.3 }} />
                        <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, transparent 0%, #1C1917 100%)' }} />
                        <div className="absolute inset-0 flex items-center justify-center text-center px-6">
                            <div>
                                <div className="w-10 h-0.5 mx-auto mb-4" style={{ backgroundColor: '#D97706' }} />
                                <p className="text-xs tracking-[0.3em] uppercase mb-3" style={{ color: '#D97706', fontFamily: "'Oswald', sans-serif", fontWeight: 500 }}>Our Story</p>
                                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '3px' }}>
                                    ABOUT VEER
                                </h1>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Mission */}
                <section className="py-16 sm:py-24 px-4 sm:px-6" style={{ backgroundColor: '#1C1917' }}>
                    <div className="max-w-[800px] mx-auto text-center">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-6" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>
                            BUILT FOR MEN WHO LEAD
                        </h2>
                        <p className="text-base leading-relaxed mb-4" style={{ color: '#A8A29E' }}>
                            VEER was born from a singular vision: to redefine Indian menswear for the modern era. We believe every man deserves clothing that matches his ambition, whether he is walking into a boardroom or down the aisle.
                        </p>
                        <p className="text-base leading-relaxed" style={{ color: '#A8A29E' }}>
                            Our collections fuse traditional Indian craftsmanship with contemporary design sensibilities, creating garments that are bold, refined, and unmistakably masculine.
                        </p>
                    </div>
                </section>

                {/* Stats */}
                <section className="py-16 px-4 sm:px-6" style={{ backgroundColor: '#292524' }}>
                    <div className="max-w-[1000px] mx-auto grid grid-cols-2 md:grid-cols-4 gap-8">
                        {stats.map((stat, i) => (
                            <div key={i} className="text-center">
                                <p className="text-3xl sm:text-4xl font-bold mb-2" style={{ fontFamily: "'Oswald', sans-serif", color: '#D97706' }}>{stat.number}</p>
                                <p className="text-xs uppercase tracking-wider" style={{ fontFamily: "'Oswald', sans-serif", fontWeight: 500, color: '#A8A29E' }}>{stat.label}</p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Values */}
                <section className="py-16 sm:py-24 px-4 sm:px-6" style={{ backgroundColor: '#1C1917' }}>
                    <div className="max-w-[1200px] mx-auto">
                        <div className="text-center mb-12">
                            <div className="w-10 h-0.5 mx-auto mb-4" style={{ backgroundColor: '#D97706' }} />
                            <h2 className="text-2xl sm:text-3xl font-bold" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>OUR VALUES</h2>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                            {values.map(({ icon: Icon, title, description }, i) => (
                                <div key={i} className="p-6" style={{ backgroundColor: '#292524', borderLeft: '3px solid #D97706' }}>
                                    <Icon size={28} style={{ color: '#D97706', marginBottom: '16px' }} />
                                    <h3 className="text-base font-semibold mb-3" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '1px' }}>{title}</h3>
                                    <p className="text-sm leading-relaxed" style={{ color: '#A8A29E' }}>{description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Team */}
                <section className="py-16 sm:py-24 px-4 sm:px-6" style={{ backgroundColor: '#292524' }}>
                    <div className="max-w-[1000px] mx-auto">
                        <div className="text-center mb-12">
                            <div className="w-10 h-0.5 mx-auto mb-4" style={{ backgroundColor: '#D97706' }} />
                            <h2 className="text-2xl sm:text-3xl font-bold" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>THE MEN BEHIND VEER</h2>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                            {team.map((member, i) => (
                                <div key={i} className="text-center">
                                    <div className="w-full overflow-hidden mb-4" style={{ aspectRatio: '3 / 4' }}>
                                        <img src={member.image} alt={member.name} className="w-full h-full object-cover" style={{ filter: 'grayscale(40%)' }} />
                                    </div>
                                    <h3 className="text-base font-semibold" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '1px' }}>{member.name}</h3>
                                    <p className="text-xs mt-1" style={{ color: '#D97706', fontFamily: "'Oswald', sans-serif", fontWeight: 500 }}>{member.role}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <Footer />
            </div>
        </>
    );
};

export default About11;
